function initChips() {
	const chips = document.querySelectorAll('.chip .countup-chip');

	function initTextHoverAnimation() {
		chips.forEach((chip) => {
			const description = chip.querySelector('.description');
			if (!description) return;

			const style = getComputedStyle(chip);
			const gap = parseFloat(style.columnGap || style.gap || 0);

			gsap.set(description, {
				width: 0,
				marginLeft: -gap,
				opacity: 0,
				overflow: 'hidden',
			});

			chip.addEventListener('mouseenter', () => {
				const fullWidth = description.scrollWidth;
				gsap.to(description, {
					width: fullWidth,
					marginLeft: 0,
					opacity: 1,
					duration: 0.5,
					ease: 'power4.out',
					overwrite: 'auto',
				});
			});

			chip.addEventListener('mouseleave', () => {
				gsap.to(description, {
					width: 0,
					marginLeft: -gap,
					opacity: 0,
					duration: 0.2,
					ease: 'power1.in',
					overwrite: 'auto',
				});
			});
		});
	}

	function countupAnimate(el, animationDuration, length, countTo) {
		const frameDuration = 1000 / 60;
		const totalFrames = Math.round(animationDuration / frameDuration);
		const logEaseOut = (t) => Math.sin((t * Math.PI) / 2);

		let frame = 0;
		el.innerText = '0';

		const counter = setInterval(() => {
			frame++;
			const t = frame / totalFrames;
			const progress = logEaseOut(t);
			const currentCount = Math.round(countTo * progress);

			el.innerText = String(currentCount).padStart(length, '0');

			if (frame === totalFrames) clearInterval(counter);
		}, frameDuration);
	}

	function countupObserve() {
		const observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0.5,
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				const chip = entry.target;
				const number = chip.querySelector('.number');

				// Prevent multiple triggers
				if (chip.dataset.counted) return;
				chip.dataset.counted = 'true';

				// Use data-countup attribute if available
				const countTo = parseInt(number.dataset.countup, 10) || 0;
				const length = String(countTo).length;

				number.style.display = 'inline-block';
				number.style.width = `${length}ch`;
				number.style.textAlign = 'left';

				countupAnimate(number, 3000, length, countTo);
			});
		}, observerOptions);

		chips.forEach((chip) => observer.observe(chip));
	}

	if (window.innerWidth > 767) {
		initTextHoverAnimation();
		countupObserve();
	}

	window.addEventListener('resize', () => {
		if (window.innerWidth < 768) return;
		initTextHoverAnimation();
		countupObserve();
	});
}

document.addEventListener('DOMContentLoaded', initChips);
